// extracted by mini-css-extract-plugin
export default {"slider":"style_slider__wExTs","buttonsContainer":"style_buttonsContainer__8IPeq"};